import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { usePermissions } from '../../../context/PermissionContext';

interface Props {
  module: string;
  action: string;
  onClick: () => void;
  icon: React.ReactNode;
  tooltip?: string;
  color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

const PermissionIconButton: React.FC<Props> = ({
  module,
  action,
  onClick,
  icon,
  tooltip,
  color = 'inherit',
  size = 'small',
  disabled = false
}) => {
  const { hasPermission } = usePermissions();

  // If user doesn't have permission, don't render the button
  if (!hasPermission(module, action)) {
    return null;
  }

  const button = (
    <IconButton
      color={color}
      size={size}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </IconButton>
  );

  // Wrap with tooltip if provided
  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default PermissionIconButton; 